import { computed as e, defineComponent as t, toDisplayString as n } from "vue";
//#region src/schema/RenderString.vue?vue&type=script&setup=true&lang.ts
var r = /*@__PURE__*/ t({
	__name: "RenderString",
	props: { value: {} },
	setup(t) {
		let r = e(() => t.value === "" ? "''" : t.value === null ? "null" : t.value === void 0 ? "undefined" : t.value);
		return (e, t) => n(r.value);
	}
});
//#endregion
export { r as default };

//# sourceMappingURL=RenderString.vue.script.js.map